import React from "react";
import { Link } from "react-router-dom";
import CRTOverlay from "./CRTOverlay";
import FluidBackground from "./FluidBackground";

function SignalLost() {
  return (
    <main className="signal-lost">
      <FluidBackground />
      <CRTOverlay />
      <section className="glass-panel signal-panel">
        <p className="system-path">ERROR 404</p>
        <h1>SIGNAL LOST</h1>
        <p>The requested route could not be located.</p>
        <Link to="/">Return to Command Center</Link>
      </section>
    </main>
  );
}

export default SignalLost;
